import React from "react";
import { useAppContext } from "../../context/appContext";
import { FancySelect } from "../workspace";

function IncludesExcludes({ optionsIndex }) {
  const { options, handleArrayChanges, lists } = useAppContext();

  const index = optionsIndex;

  const includeOptions =
    lists &&
    lists.listIncludes?.map((row) => {
      return { value: row.id, label: row.title };
    });
  const excludeOptions =
    lists &&
    lists.listExcludes?.map((row) => {
      return { value: row.id, label: row.title };
    });

  // check warranty and create/update
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleIncludes = (selected) => {
    const includeIds = selected.map((item) => item.value);

    handleArrayChanges({
      baseName: "options",
      baseArray: [...options],
      index: index,
      newValues: { includes_ids: includeIds },
    });
  };

  const handleExcludes = (selected) => {
    const excludeIds = selected.map((item) => item.value);

    handleArrayChanges({
      baseName: "options",
      baseArray: [...options],
      index: index,
      newValues: { excludes_ids: excludeIds },
    });
  };

  return (
    <div className="group whole">
      <form onSubmit={handleSubmit} className="form">
        <h3>Job Includes/Excludes</h3>
        <div className="form-center flex-parent">
          <div className="whole">
            <FancySelect
              isMulti={true}
              name="includes_ids"
              labelText="Includes"
              handleChange={handleIncludes}
              value={options[index]?.includes_ids || []}
              options={includeOptions}
            />
          </div>
          <div className="whole">
            <FancySelect
              isMulti={true}
              name="excludes_ids"
              labelText="Excludes"
              handleChange={handleExcludes}
              value={options[index]?.excludes_ids || []}
              options={excludeOptions}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
export default IncludesExcludes;
